import { render, staticRenderFns } from "./ContratoProveedorPantalla.vue?vue&type=template&id=ed5bd71c&"
import script from "./ContratoProveedorPantalla.vue?vue&type=script&lang=ts&"
export * from "./ContratoProveedorPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports